import { render, staticRenderFns } from "./user-list.vue?vue&type=template&id=4ecc979c&scoped=true&"
import script from "./user-list.vue?vue&type=script&lang=js&"
export * from "./user-list.vue?vue&type=script&lang=js&"
import style0 from "./user-list.vue?vue&type=style&index=0&id=4ecc979c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ecc979c",
  null
  
)

export default component.exports